import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {

  public isLoading = new Subject<boolean>();
  private isLocked = false;
  show() {
    this.isLoading.next(true);
  }

  hide() {
    if (!this.isLocked) {
      this.isLoading.next(false);
    }
  }

  // Lock the loader so that no one (including interceptors) can turn it off
  showAndLock() {
    this.isLocked = true;
    this.show();
  }

  // Use this if you ever need to reset the lock state
  unlock() {
    this.isLocked = false;
  }
}
